import { Box } from "@mui/material";
import { InfoOutlined, Warning } from "@mui/icons-material";
import { Tooltip } from "../../../components/shared/Tooltip";
import type {
  CareOfDelivery,
  Consignee,
} from "../../../services/prePlanningService.types";
import { dashIfEmpty } from "../../../constants/utils";

type CareOfDeliveryTooltipProps = {
  careOfDelivery?: CareOfDelivery | null;
  consignee?: Consignee | null;
};

export const CareOfDeliveryTooltip = ({
  careOfDelivery,
  consignee,
}: CareOfDeliveryTooltipProps) => {
  const tooltipText =
    careOfDelivery && consignee
      ? `${dashIfEmpty(consignee.name)}, care of ${dashIfEmpty(careOfDelivery.name)}`
      : "Shipment with MXUS-LTL service level lacks a freight broker";

  return careOfDelivery ? (
    <Box
      component="span"
      role="img"
      aria-label="Consignee and care of delivery information"
    >
      <Tooltip content={tooltipText}>
        <InfoOutlined color="primary" />
      </Tooltip>
    </Box>
  ) : (
    <Box component="span" role="img" aria-label={tooltipText}>
      <Tooltip content={tooltipText}>
        <Warning color="warning" />
      </Tooltip>
    </Box>
  );
};
